import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Results;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { jsx } from '@instructure/emotion';
import { Heading } from '@instructure/ui-heading';
import { ToggleDetails } from '@instructure/ui-toggle-details';
import { Card, CustomPropTypes, Page, QuizSessionResultHeader, QuizSessionResultInfo, ReturnButton, SessionItemResultsList, QuizzesSpinner as Spinner } from '@instructure/quiz-core';
import { RichContentRenderer } from '@instructure/quiz-rce';
import t from '@instructure/quiz-i18n/es/format-message';
import { AttemptHistory } from '@instructure/quiz-taking';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';

// ================================
// this is the results page for a student
// displayed after the student submits the quiz
// ================================

export var Results = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Results = /*#__PURE__*/function (_Component) {
  function Results() {
    _classCallCheck(this, Results);
    return _callSuper(this, Results, arguments);
  }
  _inherits(Results, _Component);
  return _createClass(Results, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getResults();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.quizSessionId !== prevProps.quizSessionId) {
        this.getResults();
      }
    }
  }, {
    key: "getResults",
    value: function getResults() {
      var _this$props = this.props,
        getResultInfo = _this$props.getResultInfo,
        quizSessionId = _this$props.quizSessionId,
        showItems = _this$props.showItems;
      getResultInfo(quizSessionId, null, void 0, true, showItems);
    }
  }, {
    key: "regradeFilter",
    value: function regradeFilter(sir) {
      return sir.regradeInfo && sir.regradeInfo.get('regraded');
    }
  }, {
    key: "renderReturnButton",
    value: function renderReturnButton() {
      if (this.props.returnToUrl) {
        return jsx("div", {
          css: this.props.styles.footer
        }, jsx(ReturnButton, {
          returnToUrl: this.props.returnToUrl
        }));
      }
    }
  }, {
    key: "renderResultsFeedback",
    value: function renderResultsFeedback() {
      var _this$props2 = this.props,
        quizSession = _this$props2.quizSession,
        resultsFeedbackFFEnabled = _this$props2.resultsFeedbackFFEnabled;
      if (resultsFeedbackFFEnabled && quizSession.resultsFeedbackEnabled && quizSession.resultsFeedback.length > 0) {
        return jsx("div", {
          css: this.props.styles.toggleDetailsWrapper
        }, jsx(ToggleDetails, {
          defaultExpanded: true,
          summary: jsx(Heading, {
            level: "h2"
          }, t('From Your Instructor'))
        }, jsx(RichContentRenderer, {
          content: quizSession.resultsFeedback
        })));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        appContainer = _this$props3.appContainer,
        attemptHistory = _this$props3.attemptHistory,
        authoritativeResult = _this$props3.authoritativeResult,
        averageScore = _this$props3.averageScore,
        findAuthoritativeAttempt = _this$props3.findAuthoritativeAttempt,
        gradingScheme = _this$props3.gradingScheme,
        needToLoad = _this$props3.needToLoad,
        onAttemptClick = _this$props3.onAttemptClick,
        quizSession = _this$props3.quizSession,
        quizSessionId = _this$props3.quizSessionId,
        restrictQuantitativeData = _this$props3.restrictQuantitativeData,
        scoreToKeep = _this$props3.scoreToKeep,
        sessionItemResults = _this$props3.sessionItemResults,
        sessionItems = _this$props3.sessionItems,
        showItems = _this$props3.showItems,
        studentHeaderDescription = _this$props3.studentHeaderDescription,
        isAutograding = _this$props3.isAutograding;
      if (needToLoad && !isAutograding) {
        return jsx(Card, {
          wrapped: true
        }, jsx(Spinner, null));
      }
      if (isAutograding) {
        return jsx(Card, {
          wrapped: true
        }, jsx(Spinner, {
          mainText: t('Auto-Grading...')
        }));
      }
      return jsx(Page, null, jsx(Card, {
        wrapped: true
      }, jsx(QuizSessionResultHeader, {
        quizSession: quizSession,
        studentDescription: studentHeaderDescription,
        regradedSessionItemResults: sessionItemResults.filter(this.regradeFilter)
      }), jsx(QuizSessionResultInfo, {
        gradingScheme: gradingScheme,
        quizSession: quizSession,
        quizSessionResult: authoritativeResult,
        restrictQuantitativeData: restrictQuantitativeData,
        sessionItemResults: sessionItemResults
      }), this.renderResultsFeedback(), this.props.children, attemptHistory && jsx("div", {
        css: this.props.styles.toggleDetailsWrapper
      }, jsx(AttemptHistory, {
        attemptHistory: attemptHistory,
        averageScore: averageScore,
        findAuthoritativeAttempt: findAuthoritativeAttempt,
        gradingScheme: gradingScheme,
        onAttemptClick: onAttemptClick,
        quizId: quizSession.quiz,
        restrictQuantitativeData: restrictQuantitativeData,
        scoreToKeep: scoreToKeep,
        selectedSessionId: quizSessionId
      })), showItems && sessionItems.size > 0 && jsx(SessionItemResultsList, {
        appContainer: appContainer,
        restrictQuantitativeData: restrictQuantitativeData,
        sessionItems: sessionItems
      }), this.renderReturnButton()));
    }
  }]);
}(Component), _defineProperty(_Results, "displayName", 'Results'), _defineProperty(_Results, "componentId", "Quizzes".concat(_Results.displayName)), _defineProperty(_Results, "propTypes", {
  appContainer: CustomPropTypes.selectors.isRequired,
  attemptHistory: CustomPropTypes.attemptHistory,
  findAuthoritativeAttempt: PropTypes.func,
  authoritativeResult: ImmutablePropTypes.record,
  averageScore: CustomPropTypes.numberInRange(0, 1),
  children: PropTypes.node,
  getResultInfo: PropTypes.func.isRequired,
  gradingScheme: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.number
  })),
  isAutograding: PropTypes.bool.isRequired,
  needToLoad: PropTypes.bool,
  onAttemptClick: PropTypes.func,
  quizSession: ImmutablePropTypes.record,
  quizSessionId: PropTypes.string.isRequired,
  resultsFeedbackFFEnabled: PropTypes.bool,
  restrictQuantitativeData: PropTypes.bool,
  returnToUrl: PropTypes.string,
  // passed in by consumer
  scoreToKeep: PropTypes.string,
  sessionItemResults: ImmutablePropTypes.list,
  sessionItems: ImmutablePropTypes.list.isRequired,
  showItems: PropTypes.bool,
  studentHeaderDescription: PropTypes.node,
  styles: PropTypes.object
}), _defineProperty(_Results, "defaultProps", {
  attemptHistory: null,
  authoritativeResult: null,
  averageScore: void 0,
  children: null,
  findAuthoritativeAttempt: null,
  gradingScheme: [],
  needToLoad: false,
  onAttemptClick: function onAttemptClick() {},
  quizSession: null,
  resultsFeedbackFFEnabled: false,
  restrictQuantitativeData: false,
  returnToUrl: null,
  scoreToKeep: 'highest',
  sessionItemResults: null,
  showItems: true,
  studentHeaderDescription: null
}), _Results)) || _class);
export default Results;